import moment from "moment";
import React from "react";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
};
const columns = () => {
  return [
    {
      title: "名称",
      name: "searchName",
      dataIndex: "searchName",
      searchItem: {}
    },
    {
      title: "名称",
      name: "name",
      dataIndex: "name",
      ellipsis: true,
      tableItem: {
        width: 200
      },
    },
    {
      title: "管理范围",
      name: "manageTargetScopeName",
      dataIndex: "manageTargetScopeName",
      ellipsis: true,
      tableItem: {
        width: 200
      },
    },
    {
      title: "创建时间",
      name: "createTime",
      dataIndex: "createTime",
      tableItem: {
        width: 220
      },
    },
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'trainPathCommentManagement/pageList',
    ...api
  }
}

const trainPathComment = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(),
    tableApi: tableApi(api)
  }
}
export default trainPathComment
